<template>
  <div>
    <h4 class="title">ایجاد برنامه غذایی</h4>
    <persian-calendar
        :events-list="events"
        :display-period.sync="period"
        :min-date="min"
        @on-day-click="onDayClick"
        disable-past-days
        class="cursor-pointer"
    >
      <template slot="event" slot-scope="i">
        <div
            style="padding: 5px;"
            :key="i.value.id"
            :class="i.value.classes"
            :style="`top:${i.top};background-color:${i.value.color};`"
            class="vpc_event"
            @click="onEventClick(i.value)"
        >
          <!--  Anything You Wish -->
          <span class="vpc_event-title" style="padding: 5px!important"  :class="i.value.classes">
              {{ i.value.title }}
            </span>
        </div>
      </template>
    </persian-calendar>

    <b-modal v-model="showModal"
             centered
             :title="`منوی غذا (${menuTitle})`"
             size="lg"
             :no-close-on-backdrop="true"
             hide-footer
    >
      <b-tabs content-class="mt-1">
        <b-tab v-if="!hideActions">
          <template #title>
            <feather-icon icon="FilePlusIcon"/>
            <span>غذای جدید</span>
          </template>
          <validation-observer
              ref="refFormObserver"
          >
            <b-form @submit.prevent="createMenu">
              <b-row>
                <b-col md="6">
                  <b-overlay :show="foodList.length === 0">
                    <validation-provider
                        #default="validationContext"
                        name="نام غذا"
                        rules="required"
                    >
                      <b-form-group>
                        <label for="food_id">
                          نام غذا
                        </label>
                        <v-select
                            v-model="food_id"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            label="name"
                            :options="foodList"
                            :reduce="food => food.id"
                        >
                        </v-select>
                      </b-form-group>
                    </validation-provider>
                  </b-overlay>
                </b-col>
                <b-col md="6">
                  <b-overlay :show="mealList.length === 0">
                    <validation-provider
                        #default="validationContext"
                        name="وعده غذایی"
                        rules="required"
                    >
                      <b-form-group>
                        <label for="organization_id">
                          وعده غذایی
                        </label>
                        <v-select
                            v-model="meal_id"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            label="name"
                            :options="mealList"
                            :reduce="meal => meal.id"
                        >
                        </v-select>
                      </b-form-group>
                    </validation-provider>
                  </b-overlay>
                </b-col>

                <b-col md="6">
                  <b-form-group description="این مقدار می تواند خالی باشد.">
                    <label for="name">
                      قیمت واقعی غذا
                    </label>
                    <b-form-input
                        v-model="price"
                        id="name"
                        placeholder="قیمت واقعی غذا را وارد نمایید"
                        trim
                    />

                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group description="این مقدار می تواند خالی باشد.">
                    <label for="name">
                      سهم قابل پرداخت کارمند
                    </label>
                    <b-form-input
                        v-model="employee_price"
                        id="name"
                        placeholder="سهم قابل پرداخت کارمند را وارد نمایید"
                        trim
                    />

                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                      label="تاریخ شروع رزرو"
                      label-for="fromDate"
                      description="در صورت وارد نکردن تاریخ مقدار پیش فرض وعده غذایی درنظر می شود."
                  >
                    <date-picker
                        v-model="fromDate"
                        type="datetime"
                        display-format="jDD jMMMM jYYYY HH:mm"
                        :min="minDate"
                        :max="maxDate"
                        clearable
                    />

                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                      label="تاریخ اتمام رزرو"
                      label-for="toDate"
                      description="در صورت وارد نکردن تاریخ مقدار پیش فرض وعده غذایی درنظر می شود."
                  >
                    <date-picker
                        v-model="toDate"
                        type="datetime"
                        display-format="jDD jMMMM jYYYY HH:mm"
                        :min="fromDate"
                        :max="maxDate"
                        @change="selectToDate"
                        clearable
                    />

                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <label></label>
                    <b-form-checkbox
                        checked="true"
                        name="check-button"
                        class="custom-control-success"
                        switch
                        v-model="isActive"
                    >
                      فعال
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>

              </b-row>
              <hr>
              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="success"
                  type="submit"
                  :disabled="onCreateProgress"
              >
                {{ onCreateProgress ? 'در حال ثبت' : 'ثبت' }}
              </b-button>
              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-secondary"
                  type="button"
                  class="float-right"
                  @click="closeModal"
              >
                انصراف
              </b-button>

            </b-form>
          </validation-observer>
        </b-tab>
        <b-tab lazy @click="getMenuSelected">
          <template #title>
            <feather-icon icon="MenuIcon"/>
            <span>منو</span>
          </template>
          <b-overlay :show="onTableProgress">
            <b-table
                :fields="fields"
                :items="items"
                hover
                striped
                responsive
            >
              <template #table-busy>
                <div class="text-center text-info my-2">
                  <b-spinner class="align-middle"/>
                  <strong> درحال دریافت اطلاعات...</strong>
                </div>
              </template>

              <template #cell(isActive)="data">
                <b-avatar
                    :id="`user-row-${data.item.id}`"
                    size="32"
                    :variant="data.value ? 'light-success': 'light-danger'"
                >
                  <feather-icon
                      :icon="data.value ? 'CheckIcon': 'XIcon'"
                  />
                </b-avatar>
              </template>
              <template #cell(action)="data">

                <b-button v-if="!hideActions"
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="outline-warning"
                          class="btn-icon rounded-circle"
                          @click="editMenu(data.item.id)"
                >
                  <feather-icon
                      icon="EditIcon"
                      class="text-warning"
                  />
                </b-button>
              </template>

            </b-table>
          </b-overlay>
        </b-tab>
      </b-tabs>
    </b-modal>
    <b-modal v-model="editModal"
             centered
             title="ویرایش منو"
             size="lg"
             :ok-disabled="onProgress"
             cancel-variant="outline-secondary"
             ok-title="ویرایش"
             cancel-title="انصراف"
             @ok="updateMenu"
             :no-close-on-backdrop="true"
    >

      <validation-observer
          ref="refFormUpdateObserver"
      >
        <b-form>
          <b-row>
            <b-col md="6">
              <b-overlay :show="foodList.length === 0">
                <validation-provider
                    #default="validationContext"
                    name="نام غذا"
                    rules="required"
                >
                  <b-form-group>
                    <label for="food_id">
                      نام غذا
                    </label>
                    <v-select
                        v-model="menu.food_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="name"
                        :options="foodList"
                        :reduce="food => food.id"
                    >
                    </v-select>
                  </b-form-group>
                </validation-provider>
              </b-overlay>
            </b-col>
            <b-col md="6">
              <b-overlay :show="mealList.length === 0">
                <validation-provider
                    #default="validationContext"
                    name="وعده غذایی"
                    rules="required"
                >
                  <b-form-group>
                    <label for="organization_id">
                      وعده غذایی
                    </label>
                    <v-select
                        v-model="menu.meal_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="name"
                        :options="mealList"
                        :reduce="meal => meal.id"
                    >
                    </v-select>
                  </b-form-group>
                </validation-provider>
              </b-overlay>
            </b-col>

            <b-col md="6">
              <b-form-group description="این مقدار می تواند خالی باشد.">
                <label for="name">
                  قیمت واقعی غذا
                </label>
                <b-form-input
                    v-model="menu.price"
                    id="name"
                    placeholder="قیمت واقعی غذا را وارد نمایید"
                    trim
                />

              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group description="این مقدار می تواند خالی باشد.">
                <label for="name">
                  سهم قابل پرداخت کارمند
                </label>
                <b-form-input
                    v-model="menu.employee_price"
                    id="name"
                    placeholder="سهم قابل پرداخت کارمند را وارد نمایید"
                    trim
                />

              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                  label="تاریخ شروع رزرو"
                  label-for="fromDate"
                  description="در صورت وارد نکردن تاریخ مقدار پیش فرض وعده غذایی درنظر می شود."
              >
                <date-picker
                    v-model="menu.fromDate"
                    type="datetime"
                    display-format="jDD jMMMM jYYYY HH:mm"
                    :min="minDate"
                    :max="maxDate"
                    clearable
                />

              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                  label="تاریخ اتمام رزرو"
                  label-for="toDate"
                  description="در صورت وارد نکردن تاریخ مقدار پیش فرض وعده غذایی درنظر می شود."
              >
                <date-picker
                    v-model="menu.toDate"
                    type="datetime"
                    display-format="jDD jMMMM jYYYY HH:mm"
                    :min="fromDate"
                    :max="maxDate"
                    @change="selectToDate"
                    clearable
                />

              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label></label>
                <b-form-checkbox
                    checked="true"
                    name="check-button"
                    class="custom-control-success"
                    switch
                    v-model="menu.isActive"
                >
                  فعال
                </b-form-checkbox>
              </b-form-group>
            </b-col>

          </b-row>
        </b-form>
      </validation-observer>

    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BInputGroup,
  BInputGroupAppend, BFormInvalidFeedback, BFormCheckbox, BModal, BTabs, BTab, BButton,
  BTable, BDropdownItem, BAvatar, BBadge, BSpinner, BDropdown
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import farsi from 'vee-validate/dist/locale/fa'
import formValidation from '@core/comp-functions/forms/form-validation'
import { required } from '@core/utils/validations/validations'
import PersianCalendar from '@/views/components/reservation/PersianCalendar.vue'
import { PersianNowDate } from '@/libs/utils'
import ripple from 'vue-ripple-directive'

export default {
  name: 'Menu_Create',
  components: {
    BDropdown,
    BSpinner,
    BBadge,
    BAvatar,
    BDropdownItem,
    BTab,
    BTabs,
    BFormCheckbox,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    VSelect,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,
    BModal,
    PersianCalendar,
    BButton,
    BTable
  },
  data() {
    return {
      onProgress: false,
      onCreateProgress: false,
      onTableProgress: false,
      showModal: false,
      fromDate: null,
      toDate: null,
      isActive: true,
      period: 'month',
      min: this.$moment(new Date(), 'jYYYY/jMM/jDD'),
      events: [],
      selectedDay: null,
      maxDate: null,
      foodList: [],
      food_id: null,
      mealList: [],
      meal_id: null,
      price: null,
      employee_price: null,
      menuTitle: '',
      fields: [
        {
          key: 'food',
          label: 'نام غذا',
        },
        {
          key: 'meal',
          label: 'وعده غذایی',
        },
        {
          key: 'period',
          label: 'بازه رزرو',
        },
        {
          key: 'creator.name',
          label: 'سازنده',
        },
        {
          key: 'isActive',
          label: 'وضعیت',
        },
        {
          key: 'action',
          label: 'عملیات',
        },
      ],
      items: [],
      editModal: false,
      menu: {},
      hideActions: false
    }
  },
  directives: {
    ripple
  },
  created() {
    localize('fa', {
      messages: farsi.messages,
    })

  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    minDate() {
      return PersianNowDate()

    }
  },
  mounted() {
    this.getEvents()
    this.getFoods()
    this.getMeal()
  },
  watch: {
    toDate(newValue, oldValue) {
      if (newValue === '') {
        this.maxDate = PersianNowDate(this.selectedDay, true)
      }
    }
  },
  methods: {
    getEvents() {
      this.$http.get('food-menus')
          .then(({ data }) => {
            if (data.status) {
              let events = data.foodMenus

              events = events.map((event) => {
                event.startDateTime = this.$moment(event.startDateTime, 'jYYYY/jMM/jDD')
                event.endDateTime = this.$moment(event.endDateTime, 'jYYYY/jMM/jDD')

                return event
              })

              this.events = events
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست غذا با خطا مواجه شد', {
                title: 'خطا در دریافت اطلاعات',
                toaster: 'b-toaster-top-right',
                variant: 'danger'
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message, {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger'
            })
          })
    },
    selectToDate(event) {
      this.maxDate = PersianNowDate(event, true)
    },
    onEventClick(e){
      this.onDayClick(this.$moment(e.startDateTime))
    },
    onDayClick(event) {
      this.selectedDay = event
      this.maxDate = PersianNowDate(event, true)
      this.menuTitle = event.format('jDD jMMMM jYYYY')
      this.hideActions = event.isBefore(this.$moment(), 'day')
      if (this.hideActions) {
        this.getMenuSelected()
      }
      this.showModal = true
    },
    getFoods() {
      this.$http.get('foods', {
        params: {
          'result': 'all',
          'only_active': 1,
          'order': 'name'
        }
      })
          .then(({ data }) => {
            if (data.status) {
              this.foodList = data.foods
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست غذا با خطا مواجه شد', {
                title: 'خطا در دریافت اطلاعات',
                toaster: 'b-toaster-top-right',
                variant: 'danger'
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger'
            })
          })
    },
    getMeal() {
      this.$http.get('meals?result=all')
          .then(({ data }) => {
            if (data.status) {
              this.mealList = data.meals
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست وعده غذایی با خطا مواجه شد', {
                title: 'خطا در دریافت اطلاعات',
                toaster: 'b-toaster-top-right',
                variant: 'danger'
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger'
            })
          })
    },
    getMenuSelected() {
      this.onTableProgress = true
      this.$http.get(`food-menus/get-menu?date=${PersianNowDate(this.selectedDay)}`)
          .then(({ data }) => {
            if (data.status) {
              this.items = data.items
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست غذا با خطا مواجه شد', {
                title: 'خطا در دریافت اطلاعات',
                toaster: 'b-toaster-top-right',
                variant: 'danger'
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? error.message, {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger'
            })
          })
          .finally(() => {
            this.onTableProgress = false
          })
    },
    createMenu() {
      this.$refs.refFormObserver.validate()
          .then(success => {
            if (success) {
              this.onCreateProgress = true
              this.$http.post('food-menus', {
                food_id: this.food_id,
                meal_id: this.meal_id,
                price: this.price,
                employee_price: this.employee_price,
                from_at: this.fromDate,
                to_at: this.toDate,
                reservation_date: this.selectedDay,
                is_active: this.isActive
              })
                  .then(({ data }) => {
                    let event = data.foodMenu
                    event.startDateTime = this.$moment(event.startDateTime, 'jYYYY/jMM/jDD')
                    event.endDateTime = this.$moment(event.endDateTime, 'jYYYY/jMM/jDD')

                    this.events.push(event)

                    this.items.push(data.tableItem)

                    if (data.status) {
                      this.$bvToast.toast('غذا با موفقیت ایجاد شد', {
                        title: 'موفقیت',
                        toaster: 'b-toaster-top-right',
                        variant: 'success',
                      })

                      this.food_id = null
                      this.meal_id = null
                      this.price = null
                      this.employee_price = null
                      this.fromDate = null
                      this.toDate = null
                      this.isActive = true

                    } else {
                      this.$bvToast.toast(data.message ?? 'در غذا خطایی رخ داده', {
                        title: 'حطا',
                        toaster: 'b-toaster-top-right',
                        variant: 'danger',
                      })
                    }
                  })
                  .catch(error => {
                    this.$bvToast.toast(error.response.data.message ?? error.message, {
                      title: 'خطا در دریافت اطلاعات',
                      toaster: 'b-toaster-top-right',
                      variant: 'danger'
                    })
                  })
                  .finally(() => {
                    this.onCreateProgress = false
                  })
            }
          })
    },
    updateMenu(e) {
      e.preventDefault()
      this.$refs.refFormUpdateObserver.validate()
          .then(success => {
            if (success) {
              this.onProgress = true
              this.$http.put(`food-menus/${this.menu.id}`, {
                food_id: this.menu.food_id,
                meal_id: this.menu.meal_id,
                price: this.menu.price,
                employee_price: this.menu.employee_price,
                from_at: this.menu.fromDate,
                to_at: this.menu.toDate,
                reservation_date: this.menu.selectedDay,
                is_active: this.menu.isActive
              })
                  .then(({ data }) => {
                    this.editModal = false

                    this.events = this.events.map((event) => {
                      if (event.id === data.foodMenu.id) {
                        event = data.foodMenu
                        event.startDateTime = this.$moment(event.startDateTime, 'jYYYY/jMM/jDD')
                        event.endDateTime = this.$moment(event.endDateTime, 'jYYYY/jMM/jDD')
                      }

                      return event
                    })

                    this.items = this.items.map((item) => {
                      if (item.id === data.tableItem.id) {
                        return data.tableItem
                      }
                      return item
                    })

                    this.editModal = false
                    if (data.status) {
                      this.$bvToast.toast('غذا با موفقیت ایجاد شد', {
                        title: 'موفقیت',
                        toaster: 'b-toaster-top-right',
                        variant: 'success',
                      })

                    } else {
                      this.$bvToast.toast(data.message ?? 'در غذا خطایی رخ داده', {
                        title: 'حطا',
                        toaster: 'b-toaster-top-right',
                        variant: 'danger',
                      })
                    }
                  })
                  .catch(error => {
                    this.$bvToast.toast(error.response.data.message ?? error.message, {
                      title: 'خطا در دریافت اطلاعات',
                      toaster: 'b-toaster-top-right',
                      variant: 'danger'
                    })
                  })
                  .finally(() => {
                    this.onProgress = false
                  })
            }
          })
    },
    closeModal() {
      this.showModal = false
    },
    editMenu(id) {
      this.$http.get(`food-menus/${id}`)
          .then(({ data }) => {
            if (data.status) {
              this.menu = data.foodMenu
              this.menu.id = id
              this.editModal = true
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست غذا با خطا مواجه شد', {
                title: 'خطا در دریافت اطلاعات',
                toaster: 'b-toaster-top-right',
                variant: 'danger'
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'خطایی رخ داده است', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger'
            })
          })
    },
  },

  setup() {
    const {
      getValidationState,

    } = formValidation(name)

    return {
      getValidationState
    }
  }
}
</script>

<style>

</style>
